import { types } from 'mobx-state-tree';

export default types.maybeNull(types.string);
